// SolarCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Memilih Jumlah Panel Surya, Baterai, dan Inverter yang Tepat";
const DESCRIPTION =
  "Hitung sistem energi surya Anda untuk rumah menggunakan kalkulator ini.";
const KEYWORDS = "energi surya, kalkulator energi surya, sistem energi surya";
const OG_URL = "https://do-calculate.com/calculator/id/solar-calculator/";
function SolarCalculator() {
  const [consumption, setConsumption] = useState(0);
  const [sunHours, setSunHours] = useState(4);
  const [panelWattage, setPanelWattage] = useState(100);
  const [batteryVoltage, setBatteryVoltage] = useState(24);
  const [cloudyDays, setCloudyDays] = useState(2);
  const [result, setResult] = useState(null);
  const handleCalculate = () => {
    const totalConsumption = consumption * 1.3;
    const panelPowerNeeded = totalConsumption / sunHours;
    const numberOfPanels = Math.ceil(panelPowerNeeded / panelWattage);
    const batteryCapacityNeeded =
      (totalConsumption * cloudyDays * 1.3) / batteryVoltage;
    const numberOfBatteries = Math.ceil(batteryCapacityNeeded / 80);
    const inverterSize = (220 * 1.3).toFixed(2);
    setResult({
      panelPowerNeeded: panelPowerNeeded.toFixed(2),
      numberOfPanels,
      batteryCapacityNeeded: batteryCapacityNeeded.toFixed(2),
      numberOfBatteries,
      inverterSize,
    });
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator gratis kami menawarkan alat yang mudah digunakan untuk menghitung sistem energi surya
                  yang ideal untuk rumah Anda. Cukup masukkan data konsumsi Anda saat ini
                  dan lokasi geografis Anda, dan dapatkan perkiraan akurat tentang jumlah panel surya,
                  baterai, dan pengontrol yang diperlukan untuk memenuhi kebutuhan Anda. Nikmati energi
                  bersih dan gratis, dan hemat tagihan listrik dengan sistem energi surya
                  yang dirancang khusus untuk Anda.
                </p>
                <p>Untuk menghitung sistem energi surya Anda, ikuti langkah-langkah berikut:</p>
                <ul>
                  <li>Hitung jumlah energi yang dikonsumsi per hari.</li>
                  <li>Hitung jumlah panel surya yang diperlukan.</li>
                  <li>Hitung jumlah baterai yang diperlukan.</li>
                  <li>Hitung ukuran pengontrol surya dan inverter.</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="consumption">
                      <label className="form-label ms-2">
                        Masukkan Total Energi yang Dikonsumsi per Hari (Watt/jam)
                      </label>
                      <input
                        id="consumption"
                        type="number"
                        value={consumption}
                        onChange={(e) => setConsumption(e.target.value)}
                        placeholder="Masukkan total energi yang dikonsumsi"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="sunHours">
                      <label className="form-label ms-2">
                        Masukkan Jumlah Jam Matahari per Hari
                      </label>
                      <input
                        id="sunHours"
                        type="number"
                        value={sunHours}
                        onChange={(e) => setSunHours(e.target.value)}
                        placeholder="Jumlah jam matahari"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="panelWattage">
                      <label className="form-label ms-2">
                        Daya Panel Surya (Watt)
                      </label>
                      <input
                        id="panelWattage"
                        type="number"
                        value={panelWattage}
                        onChange={(e) => setPanelWattage(e.target.value)}
                        placeholder="Masukkan daya panel"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="batteryVoltage">
                      <label className="form-label ms-2">
                        Tegangan Baterai (Volt)
                      </label>
                      <input
                        id="batteryVoltage"
                        type="number"
                        value={batteryVoltage}
                        onChange={(e) => setBatteryVoltage(e.target.value)}
                        placeholder="Masukkan tegangan baterai"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="cloudyDays">
                      <label className="form-label ms-2">
                        Jumlah Hari Mendung yang Diperkirakan (per minggu)
                      </label>
                      <input
                        id="cloudyDays"
                        type="number"
                        value={cloudyDays}
                        onChange={(e) => setCloudyDays(e.target.value)}
                        placeholder="Masukkan jumlah hari mendung"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p>
                        Daya yang Dibutuhkan dari Panel Surya:{" "}
                        {result.panelPowerNeeded} Watt
                      </p>
                      <p>
                        Jumlah Panel Surya yang Dibutuhkan: {result.numberOfPanels}
                      </p>
                      <p>
                        Kapasitas Baterai yang Dibutuhkan: {result.batteryCapacityNeeded}{" "}
                        Ampere Jam
                      </p>
                      <p>Jumlah Baterai yang Dibutuhkan: {result.numberOfBatteries}</p>
                      <p>Ukuran Inverter yang Dibutuhkan: {result.inverterSize} Watt</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Detail Tambahan</div>
              <div className="info-section-body">
                <p>
                  Untuk informasi lebih lanjut tentang cara menghitung sistem energi surya
                  Anda, Anda dapat mengunjungi situs web khusus atau menghubungi
                  para ahli di bidangnya.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Menghitung Energi yang Dikonsumsi
                  </h2>
                </u>
                <p>
                  Untuk menghitung total energi yang dikonsumsi per hari, Anda harus menghitung konsumsi semua
                  peralatan listrik di rumah.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    Contoh: Jika Anda menggunakan TV dengan daya 100 Watt selama 4 jam,
                    dan lampu dengan daya 10 Watt selama 5 jam, maka energi yang dikonsumsi adalah:
                  </p>
                  <ul>
                    <li>TV: 100 Watt × 4 jam = 400 Watt/jam</li>
                    <li>Lampu: 10 Watt × 5 jam = 50 Watt/jam</li>
                    <li>Total Energi yang Dikonsumsi: 400 + 50 = 450 Watt/jam</li>
                  </ul>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Menghitung Jumlah Panel Surya yang Dibutuhkan
                  </h2>
                </u>
                <p>
                  Untuk menghitung jumlah panel surya yang dibutuhkan, kita bagi daya yang dibutuhkan dari
                  panel dengan daya satu panel.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    Contoh: Jika daya yang dibutuhkan dari panel adalah 1500 Watt dan daya
                    satu panel adalah 250 Watt, maka jumlah panel yang dibutuhkan adalah:
                  </p>
                  <p>1500 Watt / 250 Watt per panel = 6 panel surya.</p>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Menghitung Kapasitas Baterai yang Dibutuhkan
                  </h2>
                </u>
                <p>
                  Untuk menghitung kapasitas baterai yang dibutuhkan, kita kalikan total energi yang dikonsumsi
                  dengan jumlah hari mendung kemudian bagi dengan tegangan baterai.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    Contoh: Jika energi yang dikonsumsi adalah 1000 Watt/jam per hari dan
                    jumlah hari mendung adalah 3, serta tegangan baterai 24 Volt, maka kapasitas
                    yang dibutuhkan adalah:
                  </p>
                  <p>(1000 Watt/jam × 3 hari) / 24 Volt = 125 Ampere Jam.</p>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Memilih Inverter yang Tepat
                  </h2>
                </u>
                <p>
                  Untuk pemilihan inverter yang optimal, pastikan inverter dapat menahan
                  total energi yang dikonsumsi ditambah beberapa cadangan.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    Contoh: Jika Anda memiliki total konsumsi 2000 Watt, Anda harus memilih
                    inverter dengan daya 2200 hingga 2500 Watt untuk kinerja terbaik dan cadangan
                    keamanan.
                  </p>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Tips untuk Meningkatkan Efisiensi Sistem Energi Surya
                  </h2>
                </u>
                <p>Untuk meningkatkan efisiensi sistem energi surya Anda, pastikan:</p>
                <ul>
                  <li>Menggunakan panel berkualitas tinggi dengan tingkat konversi tinggi.</li>
                  <li>
                    Memeriksa sudut kemiringan yang sesuai untuk panel sesuai lokasi geografis Anda.
                  </li>
                  <li>Menjaga panel tetap bersih dan bebas dari debu dan kotoran.</li>
                </ul>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}
export default SolarCalculator;